const PREFIX = '/v1/CollectiveProject/CollectiveOwnedProjectHousehold'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  SIMPLE_LIST: PREFIX + '/listSimple',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  SOCIAL_SECURITY_SET: PREFIX + '/shebaoqingkuang',
  RELATED_PHOTOS_SET: PREFIX + '/xiangguanzhaopian',
  COMP_AGREEMENT_SET: PREFIX + '/anzhixieyi',
  ATTACHMENTS_SET: PREFIX + '/fujian',
  COMP_DATA_SET: PREFIX + '/chaoqianbuchang',
  TICKET_DIFF_SET: PREFIX + '/fangpiaobucha',
  PRINT_1: PREFIX + '/print1',
  PRINT_2: PREFIX + '/print2',
  PRINT_3: PREFIX + '/print3',
  PRINT_4: PREFIX + '/print4',
  PRINT_4_V2: PREFIX + '/print4v2',
  PRINT_5: PREFIX + '/print5',
  PRINT_6: PREFIX + '/print6',
  PRINT_7: PREFIX + '/print7',
  PRINT_8: PREFIX + '/print8',
  PRINT_9: PREFIX + '/print9',
  PRINT_10: PREFIX + '/print10',
  REVIEW_LIST: PREFIX + '/listShenHe',
  TONGJI: PREFIX + '/tongji',
  HOUSE_LIST: PREFIX + '/queryHouses'
}
